import {
  GenericApiService,
  IListApiResponse,
  ISingleApiResponse,
} from "src/api/API_GenericService";
import { GeneralEndpoints } from "src/constants/apiEndpoints";
import { ISerie, ISerieAdvise, ISerieDetail } from "src/models/General/Serie.models";
import { PaginationParams } from "src/shared/models/PaginationParams.models";
import { setSerieDetailList } from "src/store/General/slices/serieDetailSlice";
import {
  setSerieList,
  addSerie,
  updateSerie,
  deleteSerie,
  setSerieToEdit,
  concatListSerie,
  setDetailsToSerieToEdit,
} from "src/store/General/slices/serieSlice";

const ApiService = new GenericApiService<ISerie>();

const GetAllSerieList = (dispatch: any, pagination?: PaginationParams) => {
  return new Promise<IListApiResponse<ISerie>>(async (resolve, reject) => {
    try {
      const response = await ApiService.getAll(
        GeneralEndpoints.serie,
        pagination?.params
      );
      if (response?.success) {
        if (pagination?.concat) dispatch(concatListSerie(response?.data));
        else dispatch(setSerieList(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const GetSerieByIdJustDetails = (dispatch: any, id: number) => {
  return new Promise<ISingleApiResponse<ISerie>>(async (resolve, reject) => {
    try {
      const response = await ApiService.getById(GeneralEndpoints.serie, id);
      if (response?.success) {
        dispatch(setSerieDetailList(response?.data?.details ?? [] as ISerieDetail[]));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const GetSerieById = (dispatch: any, id: number) => {
  return new Promise<ISingleApiResponse<ISerie>>(async (resolve, reject) => {
    try {
      const response = await ApiService.getById(GeneralEndpoints.serie, id);
      if (response?.success) {
        dispatch(setSerieToEdit(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const GetSeriesAdvises = () => {
  return new Promise<ISingleApiResponse<ISerieAdvise>>(async (resolve, reject) => {
    try {
      const response = await ApiService.getAdvises(GeneralEndpoints.serieDetail);
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const AddNewSerie = (dispatch: any, newItem: ISerie) => {
  return new Promise<ISingleApiResponse<ISerie>>(async (resolve, reject) => {
    try {
      const response = await ApiService.create(GeneralEndpoints.serie, newItem);
      if (response.success) {
        dispatch(addSerie(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const UpdateSerieOnList = (dispatch: any, newItem: ISerie) => {
  return new Promise<ISingleApiResponse<ISerie>>(async (resolve, reject) => {
    try {
      const response = await ApiService.update(GeneralEndpoints.serie, newItem);
      if (response.success) {
        dispatch(updateSerie(response?.data));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

const DeleteSerie = (dispatch: any, newItem: ISerie) => {
  return new Promise<ISingleApiResponse<ISerie>>(async (resolve, reject) => {
    try {
      const toUpdated = { ...newItem };
      toUpdated.status = false;
      const response = await ApiService.update(
        GeneralEndpoints.serie,
        toUpdated
      );
      if (response.success) {
        dispatch(deleteSerie(response?.data?.serieId));
      }
      resolve(response);
    } catch (exception) {
      reject(exception);
    }
  });
};

export {
  GetSerieById,
  GetSerieByIdJustDetails,
  GetAllSerieList,
  GetSeriesAdvises,
  AddNewSerie,
  UpdateSerieOnList,
  DeleteSerie,
};
